import Swal from 'sweetalert2';
import { RepoFactory } from '@/baseRepository/Factory';
const notificationRepository = () => RepoFactory.get('notification');
 

export default class Helper {
  
  static handleErrors(err, vue) {
    const userDetails = vue.$store?.getters?.userDetails;
   // id , phone,   
    const errResponse = err.response;
    const Messages = [];
    if (err.receive === 'front') {
      for (const key in errResponse.data) {
        if (Object.hasOwnProperty.call(errResponse.data, key)) {
          const element = errResponse.data[key];
          if (element.length) {
            Messages.push(...element);
          }
        }
      }
    } else {
      for (const key in errResponse.data.errors) {
        if (typeof errResponse.data.errors[key] === 'object') {
          let error = errResponse.data.errors[key];
          for (const key in error) {
            if (Object.hasOwnProperty.call(error, key)) {
              const Message = error[key];
              Messages.push(Message);
            }
          }
        } else {
          Messages.push(errResponse.data.errors[key]);
        }
      }
    }
    if (errResponse.status == '400' || errResponse.status == '500' || errResponse.status == '422') {
      let userphonecheck = '';
      if (userDetails?.phone) {
        userphonecheck = userDetails?.phone;
      }
      let implodeMessages = 'user phone : ' + userphonecheck + ' - ' + errResponse?.message?.substring(0, 480);
      console.log("implodeMessages in core helper", errResponse)
      console.log(errResponse.message)
      implodeMessages += Messages.map((item) => {
        return `${item}\n`;
      }).join();
      let body = {
        httpMethod: errResponse.config.method,
        url: errResponse.config.baseURL + errResponse.config.url,
        statusCode: errResponse.data.status,
        errorMessage: implodeMessages,
        referralUrl: window.location.href,
      };
      notificationRepository()
        .sendApiCallErrorNotifies(
          body,
          vue.$store.getters.notificationBaseUrl,
          {
            ClientId: vue.$store.getters.clientId,
          }
        )
        .then((data) => {
          this.getUserToMerchantPermittedUser();
          this.$dialog.message.success('دسترسی با موفقیت لغو گردید', {
            position: 'top-left',
          });
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    }

    if (errResponse == undefined) return;
    switch (errResponse.status) {
      case 400: {
        return Swal.fire({
          icon: 'error',
          title: 'خطا',
          html: 'کاربر گرامی، متاسفانه مشکل پیش‌بینی نشده‌ای بوجود آمده است. ما در اسرع وقت آنرا برطرف می‌‌کنیم. لطفاً بعداً تلاش کنید. سپاس از شکیبایی شما',
          confirmButtonText: ' بستن',
        });
      }
      case 401: {
        if (vue.$route.name !== 'login') {
          return Swal.fire({
            icon: 'error',
            title: 'خطا',
            text: 'شما مجاز به انجام عملیات نیستید. لطفا دوباره وارد شوید.',
            confirmButtonText: ' بستن',
          });
        }
        if (errResponse.data.error.length > 0) {
          const Messages = [];

          for (const key in errResponse.data.errors) {
            if (typeof errResponse.data.errors[key] === 'object') {
              let error = errResponse.data.errors[key];
              for (const key in error) {
                if (Object.hasOwnProperty.call(error, key)) {
                  const Message = error[key];
                  Messages.push(Message);
                }
              }
            } else {
              Messages.push(errResponse.data.errors[key]);
            }
          }
          let implodeMessages = '<ul>';
          implodeMessages += Messages.map((item) => {
            return `<li >${item}</li>`;
          }).join();
          implodeMessages += '</ul>';
          return Swal.fire({
            icon: 'error',
            title: 'خطا',
            html: implodeMessages,
            confirmButtonText: ' بستن',
          });
        }
        return Swal.fire({
          icon: 'error',
          title: 'خطا',
          text: 'شما مجاز به انجام عملیات نیستید. لطفا دوباره وارد شوید.',
          confirmButtonText: ' بستن',
        });
      }
      case 403: {
        return Swal.fire({
          icon: 'error',
          title: 'خطا',
          text: 'متاسفیم. شما دسترسی های لازم را ندارید.',
          confirmButtonText: ' بستن',
        });
      }
      case 404: {
        return Swal.fire({
          icon: 'error',
          title: 'خطا',
          text: 'اطلاعات مورد نظر یافت نشد.',
          confirmButtonText: ' بستن',
        });
      }
      case 422: {
        let implodeMessages = '';
        implodeMessages += Messages.map((item) => {
          return `${item}\n`;
        }).join('');
        return Swal.fire({
          icon: 'error',
          title: 'خطا',
          text: implodeMessages,
          confirmButtonText: ' بستن',
        });
      }
      //  server errors
      case 500: {
        return Swal.fire({
          icon: 'error',
          title: 'خطای سیستمی',
          text: 'بنظر می رسد مشکلی در سرویس وجود دارد. ضمن پوزش، این مشکل بطور خودکار به اطلاع مدیریت رسیده و مرتفع خواهد شد.',
          confirmButtonText: ' بستن',
        });
      }
      default: {
        return Swal.fire({
          icon: 'error',
          title: 'خطا',
          text: 'مشکل پیش بینی نشده ای وجود دارد. در صورت تکرار گزارش دهید.',
          confirmButtonText: ' بستن',
        });
      }
    }
  }
}
